import { object, string } from "yup";

export const signUp = object({
  first_name: string().min(1).max(25).required("First name is required"),
  last_name: string().min(1).max(35).required("Last name is required"),
  phone: string()
    .matches(
      /^\(\d{3}\) \d{3}-\d{4}$/,
      "Phone number must follow the pattern (123) 456-7890"
    )
    .required("Phone is required"),
  email: string().email().required("Email is required"),
  company_name: string().min(1).max(50).required("Company name is required"),
  website: string().test("is-valid-url", "Must be a valid URL", (value) => {
    if (!value) return true;
    return /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-za-z0-9#]+)*\/?(\?[a-za-z0-9-_]+=[a-za-z0-9-%]+&?)?$/.test(
      value
    );
  }),
  units: string()
    .min(1)
    .matches(/^\d+$/, "Units must be a positive number")
    .required("Units number is required"),
  password: string().min(8).max(50).required("Password is required"),
  property_management_system: string()
});
